import { createContext } from "react";

type ContextType = {
    setFlickityInstance(instance: Flickity): void;
    instance: Flickity | null;
} | null;

const FlickityCarouselContext = createContext<ContextType>(null);

export default FlickityCarouselContext;
